import React from "react";
import logo from "../../assets/logo.png";
import { AiOutlineLogin } from "react-icons/ai";
import {
  MdProductionQuantityLimits,
  MdCategory,
  MdOutlineBookmarks,
  MdDashboard,
} from "react-icons/md";
import { FaCircleUser } from "react-icons/fa6";
import { FaRegQuestionCircle } from "react-icons/fa";


import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const options: any = [
    {
      id: 1,
      title: "Dasboard",
      icon: <MdDashboard className="text-xl font-semibold" />,
      url: "/",
    },

    {
      id: 2,
      title: "Products",
      icon: <MdProductionQuantityLimits className="text-xl font-semibold" />,
      url: "/products",
    },
    {
      id: 3,
      title: "Categories",
      icon: <MdCategory className="text-xl font-semibold" />,
      url: "/categories",
    },
    {
      id: 4,
      title: "Orders",
      icon: <MdOutlineBookmarks className="text-xl font-semibold" />,
      url: "/orders",
    },
    {
      id: 5,
      title: "Users",
      icon: <FaCircleUser className="text-xl font-semibold" />,
      url: "/users",
    },
  ];

  return (
    <div className="p-2 h-full flex flex-col justify-between">
      <div>
        <img src={logo} className="w-[10rem]" />
        <div className="mt-5">
          {options.map((option: any) => {
            return (
              <div
                key={option.id}
                onClick={() => navigate(option.url)}
                className={`flex gap-4 items-center w-full px-4 py-2 cursor-pointer rounded-lg mb-2 select-none	 ${
                  location.pathname === option.url
                    ? "bg-blue-500 text-white"
                    : "text-black"
                }`}
              >
                <h3 className="font-poppins font-medium">{option.icon}</h3>
                <h3 className="text-md  font-poppins font-medium">
                  {option.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>

      <div>
        <div
          onClick={() => {
            // localStorage.removeItem("isloggedIn");
            // navigate("/login", { replace: true });
          }}
          className="flex gap-4 hover:bg-[#fafafa] items-center w-full px-4 py-2 cursor-pointer rounded-lg mb-2"
        >
          <h3 className="font-poppins font-medium">
            <FaRegQuestionCircle />
          </h3>
          <h3 className="font-poppins font-medium">Support</h3>
        </div>
        <div
          onClick={() => {
            localStorage.removeItem("isloggedIn");
            navigate("/login", { replace: true });
          }}
          className="flex gap-4 hover:bg-[#fafafa] items-center w-full px-4 py-2 cursor-pointer rounded-lg mb-2"
        >
          <h3 className="font-poppins font-medium">
            <AiOutlineLogin />
          </h3>
          <h3 className="font-poppins font-medium">Logout</h3>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
